import { useEffect } from "react";

export const useLiveChat = () => {
  useEffect(() => {
    // Don't inject if already present
    if (document.getElementById("zsiqscript")) return;

    const bootstrapScript = document.createElement("script");
    bootstrapScript.setAttribute("type", "text/javascript");
    bootstrapScript.setAttribute("id", "scriptid");
    bootstrapScript.text = `window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}`;

    const widgetScript = document.createElement("script");
    widgetScript.setAttribute("id", "zsiqscript");
    widgetScript.src =
      "https://salesiq.zohopublic.eu/widget?wc=siq7b375e6e29e57c287adce25599f9910046b93a0be234a7db00af173d9448be4b975d7e2ebba20b9be092d1276f8790a6";
    widgetScript.defer = true;

    document.body.appendChild(bootstrapScript);
    document.body.appendChild(widgetScript);

    return () => {
      document.getElementById("scriptid")?.remove();
      document.getElementById("zsiqscript")?.remove();
    };
  }, []);
};
